
export default {
  name: 'title-animation',
  mixins: [],
  data () {
    return {
      needIntersection: true,
      mobile: false
    }
  },
  props: {
    delay: 0,
    text: '',
    hoverable: {
      type: String,
      default: ''
    },
    mobileAnimated: {
      type: Boolean,
      default: false
    }
  },

  mounted () {
    this.mobile = this.$store.state.ua.platform.type !== 'desktop'
    this.$el._show = this.show.bind(this)
    this.$el._hide = this.hide.bind(this)
    this.splited = new SplitText(this.$refs.split, { type: 'lines', linesClass: 'line' })
  },
  methods: {
    show () {
      this.$el.classList.remove('up')
      this.$el.classList.remove('down')
    },
    hide (up = true) {
      if (up) {
        this.$el.classList.add('up')
      } else {
        this.$el.classList.add('down')
      }
    },
    mouseenter () {
      this.$refs.split.classList.add('is-hover')
    },
    mouseleave () {
      this.$refs.split.classList.remove('is-hover')
    }
  }
}
